import React from 'react';
import PropTypes from 'prop-types';
import NfibComFooter from '../NfibSiteChrome/NfibComFooter';

const Footer = () => <NfibComFooter />;

Footer.propTypes = {
  version: PropTypes.string.isRequired,
};

export default Footer;



// WEBPACK FOOTER //
// ./src/common/components/Layout/Footer/index.js